import { useState } from 'react';
import { uploadFile } from '../lib/upload';
import { Spinner } from './ui';
import { Icon } from './icons';

export function PhotoUpload({
  value,
  onChange,
  prefix = 'vehicles',
}: {
  value?: string;
  onChange: (url: string) => void;
  prefix?: string;
}) {
  const [uploading, setUploading] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const onFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    setErr(null);
    try {
      onChange(await uploadFile(file, prefix));
    } catch {
      setErr('Falha no upload');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="flex items-center gap-3">
      <div className="h-16 w-24 rounded-lg bg-surface-2 overflow-hidden grid place-items-center shrink-0 border border-border">
        {value ? (
          <img src={value} alt="prévia" className="h-full w-full object-cover" />
        ) : (
          <Icon name="car" className="h-6 w-6 text-muted" />
        )}
      </div>
      <label className="cursor-pointer">
        <span className="inline-flex items-center gap-2 text-sm px-3 py-2 rounded-lg bg-surface-2 border border-border hover:border-border-strong transition-colors">
          {uploading ? <Spinner className="h-4 w-4" /> : <Icon name="plus" className="h-4 w-4" />}
          {uploading ? 'Enviando…' : value ? 'Trocar foto' : 'Enviar foto'}
        </span>
        <input type="file" accept="image/*" capture="environment" className="hidden" onChange={onFile} />
      </label>
      {err && <span className="text-xs text-st-danger">{err}</span>}
    </div>
  );
}
